import React from "react"
import { Box, Container, Image as GatsbyImage } from "@chakra-ui/react"

import { useImage } from "@hooks/useImage"

const Image = ({ image, alignment, theme, padding, paddingTop, paddingBottom }: GatsbyTypes.SanitySectionImage) => {
  const { getGatsbyImage } = useImage()
  const gatsbyImage = getGatsbyImage(image)

  return (
    <Box
      bg={theme === "Dark" ? "brand.beige.dark" : "white"}
      textAlign={alignment?.toString() || "center"}
      w={["unset", "648px"]}
      margin={"auto"}
      py={padding ? 4 : 0}
      paddingTop={paddingTop ? 4 : 0}
      paddingBottom={paddingBottom ? 4 : 0}
    >
      <Container>
        <GatsbyImage {...gatsbyImage} borderRadius="xs" margin={"auto"} />
      </Container>
    </Box>
  )
}

export default Image
